import Vue from "vue";
import Router from "vue-router";
import Step from "@/components/Step.vue";
import ShowErrorPresupuesto from "@/components/ShowErrorPresupuesto";
import actions from "@/util/actions.js";
import store from "@/store/store.js";

Vue.use(Router);

let router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },

  mode: "history",

  routes: [{
      path: "/tarificador/p/:presCodif/:np",
      name: "pres",
      component: Step,
      beforeEnter: async function (to, from, next) {
        if (!store.step.idPresupuesto) {
          console.log(
            "Refresh: " + to.params.presCodif + " np: " + to.params.np
          );
          store.step.idPresupuesto = to.params.presCodif;
          await actions.getFetchState(to.params.presCodif);
        }
        next();
      }
    },

    {
      path: "/tarificador/c/:clase/:codprom?",
      name: "clase",
      component: Step,
      beforeEnter: async function (to, from, next) {
        if (to.params.clase === 'AUTO') {
          document.title = 'Calcular Seguro de Coche - Precio Seguro de Coche Online';
        } else if (to.params.clase === 'MOTO') {
          document.title = 'Calcular Seguro de Moto - Precio Seguro de Moto Online';
        } else {
          document.title = 'Calcular Precio Seguro de Coche y Moto Online Barato con MMT';
        }
        let resp = await actions.getNextPaso("tipoAutomovil", to.params.clase);
        if (resp.codigo == 0) {
          next({
            name: "pres",
            params: {
              np: resp.data.nombrePaso,
              presCodif: resp.data.idPresupuesto
            }
          });
        }
      }
    },

    {
      path: "/tarificador/errorEnPresupuesto",
      name: "ShowErrorPresupuesto",
      component: ShowErrorPresupuesto,
      props: true
    },

    {
      path: "/tarificador",
      name: "init",
      component: Step
    },

    {
      path: "*",
      name: "notFound",
      component: Step,
      beforeEnter: function (to, from, next) {
        next({
          name: "init"
        });
      }
    }
  ]
});

export default router;